import type { DefaultSuperInsuranceRuleSet } from "./types.js";

// default-super-insurance ruleset for FY2025-26 (1 July 2025 – 30 June 2026).
//
// The "rules" here are a handful of STATUTORY triggers from the 2019 super
// reforms — they are not annually-repriced dollar tables, so this ruleset is
// light and changes only on legislative reform. FY-versioned regardless, so a
// historical re-run resolves against the rules in force that year.
//
//   PMIF — Putting Members' Interests First (Treasury Laws Amendment (Putting
//   Members' Interests First) Act 2019, C2019A00079). Commenced 3 Oct 2019;
//   operative cessation date 1 APRIL 2020. RSE licensees must not provide
//   insurance on an OPT-OUT basis to:
//     - new members UNDER AGE 25, OR
//     - accounts with a balance that has never reached $6,000,
//   unless the member elects (opts in). Once the member turns 25 and/or the
//   balance reaches $6,000, default (opt-out) cover may be provided.
//
//   PYS — Protecting Your Super Package (Treasury Laws Amendment (Protecting
//   Your Superannuation Package) Act 2019). Effective 1 July 2019. Trustees
//   must SWITCH OFF insurance on accounts INACTIVE for 16 MONTHS (no
//   contribution or rollover received) unless the member elects to keep it
//   (notices issued at 9 / 12 / 15 months).
//
// Sources verified against APRA (regulator primary) + ASIC MoneySmart; see the
// figure ledger (figure #3, CITED). NOTE the "2019 reforms" shorthand is loose
// for PMIF — its operative cessation date is 1 April 2020 (copy says so).
// Never edit a shipped ruleset to "fix" a later reform — author a new
// fyXXXX-XX.ts and register it.
export const fy2025_26: DefaultSuperInsuranceRuleSet = {
  engine: "default-super-insurance",
  fy: "2025-26",
  effectiveFrom: "2025-07-01",
  effectiveTo: "2026-06-30",
  sources: {
    // PMIF (age-25 / $6,000) — APRA FAQ (regulator primary).
    pmifApra:
      "https://www.apra.gov.au/putting-members%E2%80%99-interests-first-%E2%80%93-frequently-asked-questions",
    // PYS (16-month inactivity) — APRA FAQ (regulator primary).
    pysApra: "https://www.apra.gov.au/protecting-your-super",
    // ASIC MoneySmart — "Insurance through super" (the neutral cautions).
    moneysmart:
      "https://moneysmart.gov.au/how-life-insurance-works/insurance-through-super",
    // PMIF Act on the register (commenced 3 Oct 2019; operative 1 April 2020).
    pmifAct: "https://www.legislation.gov.au/Details/C2019A00079",
  },
  sourcesVerifiedAt: "2026-06-22",
  // PMIF: default (opt-out) cover provided only from age 25.
  minAgeForDefaultCover: 25,
  // PMIF: default (opt-out) cover provided only once balance reaches $6,000.
  minBalanceForDefaultCover: 6_000,
  // PYS: insurance switched off after 16 months of inactivity unless elected.
  inactiveMonthsCancelThreshold: 16,
};
